import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const DayCircle = styled(Box)<{ isHoliday?: boolean }>(
  ({ theme, isHoliday }) => ({
    width: 26,
    height: 26,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isHoliday
      ? theme.palette.warning.main
      : theme.palette.primary.main,
    color: 'white'
  })
);
